<div [ngClass]="{ 'alert-dialog': isDialog }">
    <nb-alert
        class="mt-2"
        [status]="status ?? 'info'"
        [closable]="closable"
        (close)="onClose()">
        @if (title[status]) {
            <div
                class="align-items-baseline"
                [ngClass]="alertClasses">
                <strong class="mr-2">{{ title[status] }}</strong>
                @if (message) {
                    <span [innerHtml]="message"></span>
                }
            </div>
        }
        @if (items?.length) {
            <ul class="mt-1">
                @for (item of items; track item) {
                    <li
                        class="mb-2"
                        [innerHtml]="item"></li>
                }
            </ul>
        }
    </nb-alert>
</div>
